// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:04:25

export default {
  "id": "stickman-punishment",
  "slug": "stickman-punishment",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3dd5799025544b7ba476f6dc498d6c83-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3dd5799025544b7ba476f6dc498d6c83/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Stickman Punishment",
      "description": "When a mysterious radiation blast grants Stickman and his friends superpowers, heartbreak quickly turns into a quest for revenge! Betrayed by his best friend over a girl, Stickman discovers he can morph into any shape imaginable. Now, he’s ready to use his new abilities to create chaos and keep the pair apart. Dive into this action-packed story filled with unique animations, clever payback strategies, and endless creativity!",
      "instructions": "Use a computer mouse to control the game.\nIf you have a mobile device, then use a stylus or a finger.\nIt is necessary to watch the story animation and choose a way to punish the Stickman. You need to click on the buttons to see all the punishments of the Stickman.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "escape",
        "point-and-click",
        "stickman",
        "story"
      ]
    },
    "zh-CN": {
      "title": "棍人惩罚",
      "description": "当神秘的辐射爆发放给棍人及其朋友们超能力时，心痛迅速转变为复仇之旅！被最好的朋友为了一个女孩背叛，棍人发现他可以变成任何可想象形状。现在，他准备利用他新获得的能力制造混乱，并让这对恋人分开。深入这个充满独特动画、巧妙复仇策略和无限创造力的动作故事！",
      "instructions": "使用电脑鼠标控制游戏。\n如果您有移动设备，则使用触控笔或手指。\n需要观看故事动画并选择惩罚 Stickman 的方式。您需要点击按钮以查看 Stickman 所受的所有惩罚。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "逃离",
        "点击式冒险",
        "小丑人",
        "故事"
      ]
    },
    "zh-TW": {
      "title": "棍人懲罰",
      "description": "當神秘放射線爆發賦予 Stickman 和他的朋友超能力時，傷心迅速轉變成報仇的冒險！因為一個女孩被最好朋友背叛，Stickman 發現他可以變形成任何可想像的形狀。現在，他準備利用他的新能力製造混亂，並讓這對情侶分開。沉浸這個充滿動作場面的故事中，內含獨特動畫、巧妙的報復策略和無盡的創意！",
      "instructions": "使用滑鼠控制遊戲。\n如果您有行動裝置，則可以使用筆或手指。\n必須觀看故事動畫並選擇對Stickman進行懲罰的方式。您需要點擊按鈕以查看所有對Stickman的懲罰。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "逃離",
        "點選",
        "木偶人",
        "故事"
      ]
    },
    "zh-HK": {
      "title": "竹人懲戒",
      "description": "當一場神秘的輻射爆發賦予 Stickman 及其朋友超能力時，心碎迅速轉變成尋求報復的任務！因為一個女孩被最好的朋友背叛，Stickman 發現自己能夠變成任何可想像的形狀。現在他準備利用自己的新能力制造混亂，並將這對情侶分開。深入這個充滿動作場面的故事，內含獨特的動畫、巧妙的報復策略和無盡的創意！",
      "instructions": "使用電腦滑鼠控制遊戲。\n如果你有行動裝置，則可以使用筆或手指。\n必須觀看故事動畫並選擇對 Stickman 進行懲罰的方式。你需要點擊按鈕以查看 Stickman 的所有懲罰。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "逃離",
        "點擊互動",
        "木人",
        "故事"
      ]
    },
    "ja": {
      "title": "スティックマンパニッシュメント",
      "description": "謎の放射線爆発がStickmanと彼の友達に超能力を授ける中、悲しみはすぐに報復のための冒険に変わります！女の子のことで最良の友達に裏切られたStickmanは、どんな形にも変身できることを発見します。今や彼は新しい能力を使って混乱を起こし、その二人を引き離す準備ができています。ユニークなアニメーションや賢い復讐の戦略、無限の創造力が満載のアクションストーリーに没頭してください！",
      "instructions": "コンピュータのマウスを使用してゲームを操作してください。\nモバイルデバイスをお持ちであれば、スタイラスや指を使用してください。\n物語のアニメーションを見て、 Stickmanを処罰する方法を選ぶ必要があります。ボタンをクリックして、 Stickmanのすべての処罰を見る必要があります。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "脱出",
        "ポイント＆クリック",
        "ストラックマン",
        "物語"
      ]
    },
    "ko": {
      "title": "스틱맨 형벌",
      "description": "미스터리한 방사능 폭발이 스틱맨과 그 친구들에게 슈퍼파워를 부여하자마자, 가슴 아픔이 복수의 여정으로 빠르게 변한다! 여자아이를 위해 자신의 최良친구에 배신당한 스틱맨은 어떤 형상이든 변신할 수 있는 것을 발견한다. 지금 그는 새로운 능력을 사용하여 혼란을 일으키고 그 두 사람을 분리시키기 위해 준비가 되어 있다. 독특한 애니메이션, 지혜로운 복수 전략, 끝없는 창의성이 가득한 이 액션 packed 스토리에 뛰어들어 보세요!",
      "instructions": "컴퓨터 마우스를 사용하여 게임을 제어하세요.\n모바일 기기가 있으면 펜슬이나 손가락을 사용하세요.\n스토리 애니메이션을 관찰하고 Stickman을 처벌하는 방법을 선택해야 합니다. Stickman의 모든 처벌을 볼 수 있는 버튼을 클릭하세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "탈출",
        "포인트앤클릭",
        "스틱맨",
        "이야기"
      ]
    },
    "fr": {
      "title": "Homme en stick punition",
      "description": "Quand une émission mystérieuse de radiation confère à Stickman et à ses amis des pouvoirs supérieurs, le chagrin se transforme rapidement en quête de revanche ! Trahi par son meilleur ami pour une fille, Stickman découvre qu'il peut se métamorphoser en n'importe quelle forme imaginable. Maintenant, il est prêt à utiliser ses nouvelles capacités pour semer le chaos et maintenir la paire séparée. Plongez dans cette aventure haletante remplie d'animations uniques, de stratégies de revanche ingénieuses et d'une créativité infinie !",
      "instructions": "Utilisez une souris pour contrôler le jeu.\nSi vous avez un appareil mobile, utilisez un stylet ou un doigt.\nIl est nécessaire de regarder l'animation de l'histoire et de choisir un moyen de punir le Stickman. Vous devez cliquer sur les boutons pour voir toutes les punitions du Stickman.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "évasion",
        "clic et clique",
        "stickman",
        "histoire"
      ]
    }
  }
};
